export default __webpack_public_path__ + "static/media/grapes.bd294ee0.jpg";